import { Chip } from "@mui/material";

const FilterChip = ({ label, icon: Icon, selected, onClick }) => (
  <Chip
    icon={Icon ? <Icon sx={{ fontSize: 16 }} /> : undefined}
    label={label}
    size="small"
    onClick={onClick}
    sx={{
      cursor: "pointer",
      bgcolor: selected ? "#046287" : undefined,
      color: selected ? "white" : undefined,
      "& .MuiChip-icon": { color: selected ? "white" : undefined },
      "&:hover": { bgcolor: selected ? "#046287" : undefined },
    }}
  />
);

export default FilterChip;
